import { render } from "./QuestionThreeScreen.vue?vue&type=template&id=4f6b3ee3&scoped=true&lang=html"
import script from "./QuestionThreeScreen.vue?vue&type=script&lang=js"
export * from "./QuestionThreeScreen.vue?vue&type=script&lang=js"

import "./QuestionThreeScreen.vue?vue&type=style&index=0&id=4f6b3ee3&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/progressive/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6b3ee3"]])

export default __exports__